module.exports = __webpack_public_path__ + "static/media/S_F02.47ab9051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/S_F02.png
// module id = 107
// module chunks = 0